import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common-service';
import { MessageService } from 'primeng/api';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Clipboard } from '@angular/cdk/clipboard';
import { Router } from '@angular/router';
import { MarkdownService } from '../markdown-service';
import { QuestionService } from '../question.service';
import { SanitizationService } from '../sanitization.service';
@Component({
  selector: 'app-question-answer',
  templateUrl: './question-answer.component.html',
  styleUrl: './question-answer.component.scss'
})
export class QuestionAnswerComponent implements OnInit {
  availableCollections:any
  selectedCollection:any
  isExpanded: boolean=false;
  query: string = '';
  searchkey:any=''
  username:any
  loader = false
  saved_answers: any[]=[];
  thumbsupClicked: { [key: number]: boolean } = {};
  thumbsdownClicked: { [key: number]: boolean } = {};
  likeCounts: { [key: number]: number } = {};
  dislikeCounts: { [key: number]: number } = {};
  searchPerformed: boolean=false
  filteredQuestions:{question:string}[] = [];
  topratedQuestion: any;
  isCopied: boolean=false;
  showmodal=false
  modalloader=true
  mappedAnswer: any;
  mappedQuestion: any;
  dialogheader="Map answer to new question"
  mappedId: any;
  questionId: any;
  answer: any='';
  maploader: boolean=false;
  collectionId: any;
  constructor(private api:CommonService,private messageService: MessageService,private sanitizer: DomSanitizer,
  private clipboard: Clipboard ,private router: Router, private markdownService: MarkdownService,private qusService: QuestionService,
  private sanitizeService:SanitizationService){ this.username = localStorage.getItem('username')}
  ngOnInit(): void {
    this.api.getMethod('get-collections/v2').subscribe((data: any) => {
      this.availableCollections = data;
      this.selectedCollection = localStorage.getItem('selectedCollection') ? localStorage.getItem('selectedCollection') : data[0].collectionName;
      this.fetchtopViewedQuestion();
      let collection = localStorage.getItem('selectedCollection');
      if (collection == undefined) {
        localStorage.setItem('selectedCollection', this.selectedCollection)
      }
      
    });    
  }
  search(event: any) {
    let query = event.query || this.query; 
    if (this.selectedCollection && query.length >1) {
      this.loader = true;
      let payload = {
        "collectionName": this.selectedCollection,
        "question": query,
      };
      this.qusService.faqssearch(payload).subscribe({
        next: (res: any) => {
          this.loader = false;
           this.filteredQuestions = res.data.map((q:any) => ({question: this.cleanHtml(q.question)}));
        },
        error: (err: any) => {
          this.loader = false;
          console.error('Error searching questions:', err);
        }
      });
    } else {
      this.filteredQuestions = [];
    }
  }

  onSelect(event: any) {
    this.query = event.value.question;
    this.performSearch()
  }

  performSearch() {
    if (this.selectedCollection && this.query.length > 1) {
      this.loader = true;
      let payload = {
        "collectionName": this.selectedCollection,
        "question":this.query,
        "attributes":["id","question","answer","collection_name","like","dislike","created_at","updated_at","answer_approved","knowledge_gap","documents_referred"]

      };
      this.qusService.faqssearch(payload).subscribe({
        next: (res: any) => {
          this.query='';
          this.loader = false;
          this.saved_answers = res.data;
          this.searchPerformed = true;
        },
        error: (err: any) => {
          this.loader = false;
          console.error('Error searching :', err);
        }});
  }
  else{return;}
}
cleanHtml(text: string): string {
  return this.sanitizeService.cleanHtml(text)
}
  changeCollection(e:any){
    this.selectedCollection = e.value
    localStorage.setItem('selectedCollection',this.selectedCollection)
    this.query="";
    this.saved_answers=[];
    this.searchPerformed=false
    this.fetchtopViewedQuestion()
  }
  getFilteredDocuments(documents: any[]): any[] {
    return documents.filter((doc: any) => doc.document_name && doc.document_name.trim() !== '');
  }

  downloadContent(contentToDownload:string){
  let content: string;
  if (typeof contentToDownload === 'string') {
    content = contentToDownload.replace(/\\n/g, '\n').replace(/\\t/g, '\t')
  } else {
    content = this.sanitizer.sanitize(1, contentToDownload) || '';
  }

  const blob = new Blob([content], { type: 'text/plain' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'downloadedContent.txt';  // Default filename
  a.click();
  window.URL.revokeObjectURL(url);
}
serchans(data:any){
  this.query=data.question
  this.performSearch()
}
copyContent(contentToCopy:string) {
  let content:string;
  if (typeof contentToCopy == 'string') {
    content = contentToCopy.replace(/\\n/g, '\n').replace(/\\t/g, '\t')
  } else {
    content = this.sanitizer.sanitize(1, contentToCopy) || '';
  }

  this.clipboard.copy(content);
  this.isCopied = true;
  setTimeout(() => {
    this.isCopied = false;
  }, 5000);
}


toggleFullScreen(savedanswer:any) {
  this.isExpanded = true;
  const url = this.router.serializeUrl(
  this.router.createUrlTree(['/faq'], { queryParams: { questionid: savedanswer.id } })
  );

  window.open(url, '_blank');
}
navigateTogetanswer(savedanswer:any){
  this.router.navigate(['/get-answer',{ question: savedanswer }]);
}
getFeedbackCounts(answerId: number): void {
  this.qusService.getFeedback(answerId).subscribe(response => {
    const answer = this.saved_answers.find(a => a.id === answerId);
    if (answer) {
      answer.like = response.data.likes;
      answer.dislike = response.data.dislikes;
    }
  });
}
thumbsup(answerId:any){
  this.qusService.updateFeedback(answerId, true).subscribe(response => {
    if (response.code == 200) {
      this.thumbsupClicked[answerId] = true;
      this.thumbsdownClicked[answerId] = false;
      this.getFeedbackCounts(answerId)
    }
  });
}
thumbsdown(answerId:any){
  this.qusService.updateFeedback(answerId, false).subscribe(response => {
    if (response.code === 200) {
      this.thumbsdownClicked[answerId] = true;
      this.thumbsupClicked[answerId] = false;
      this.getFeedbackCounts(answerId)
    }
  });
}

sanitizeMessage(message: string): SafeHtml {
  return this.sanitizeService.sanitizeMessage(message);
 }
 fetchtopViewedQuestion(){
  if (this.selectedCollection) {
    this.collectionId = this.availableCollections.find((x: any) => x.collectionName == this.selectedCollection)?.collection_id;
  }
  this.qusService.getTopViewedQuestions(5,this.selectedCollection).subscribe({
    next:(res:any)=>{
      this.topratedQuestion= res.data;

    },
    error:(error:any)=>{
    }
 })
}
OpentomapAnswer(e:any){
  this.answer='',
  this.searchkey=''
  this.showmodal = true;
  this.modalloader=true
  this.mappedQuestion=e.question;
  this.mappedAnswer=e.answer
  this.mappedId=e.id
   this.modalloader=false
}
mapsearch(event:any){
  let query = event.query 
  if (this.selectedCollection && query.length >1) {
  let payload={
    "collectionName": this.selectedCollection,
    "question": query,
    "filter": [{"answer_approved": ["eq", 1]},{"id": ["notIn", [this.mappedId]]}],
    "attributes": ["id","question"]
}
  this.qusService.faqssearch(payload).subscribe({
    next: (res: any) => {
       this.filteredQuestions = res.data.map((q:any) => ({question: this.cleanHtml(q.question),id: q.id}));
    },
    error: (err: any) => {
      console.error('Error searching questions:', err);
    }
  });
} else {
  this.filteredQuestions = [];
}

}
onSelectmap(event:any)
{
  this.questionId = event.value.id;
    this.performmapSearch()
}
performmapSearch(){
  if (this.selectedCollection && this.questionId) {
    this.maploader = true;
   
    this.qusService.getQnById(this.questionId).subscribe({next:(res)=>{
      // this.question=res.data.question
      this.answer=res.data.answer
      this.maploader=false
    },
    error: (err: any) => {
      this.loader = false;
      console.error('Error fetching question details:', err);
    }});
}
}
mapAnswer(){
  let payload = {
    "collectionName": this.selectedCollection,
    "question_id": this.mappedId,
    "new_mapping": this.questionId,
    "question": this.searchkey.question,
    "collection_id": this.collectionId
  }
  this.modalloader=true
  this.qusService.updateMappedAnswer(payload).subscribe({next:(response)=>{
    this.modalloader=false
    this.showmodal=false
    this.messageService.add({ severity: 'success', detail: response.message })
  },
  error: (err: any) => {
    this.modalloader = false;
    this.messageService.add({ severity: 'error', detail: err.error.message });
    this.showmodal=false
    console.error('Error updating mapped question', err);
  }});
}
Onclose(){this.showmodal=false}
onDialogHideaddcollection(){this.showmodal=false}
knowledgegap(questionId:number){
  let answer = this.saved_answers.find((ans:any) => ans.id === questionId);

  if (answer) {
    const body = {
      id: questionId,
      value: !answer.knowledge_gap
    };

    this.api.putMethod("canned/updateKnowledgeGap", body).subscribe({
      next: (data: any) => {
        if (data.data.knowledge_gap === true) {
          answer.knowledge_gap = true;
        } else {
          answer.knowledge_gap = false;
        }
      },
      error: (error: any) => {
        console.error('Error updating knowledge gap:', error);
      }
    });
  }
}
navigateToDoc(doc:any){
  const dataToPass = { documentId: doc.document_id, collectionId: this.collectionId };
  this.api.setData(dataToPass);
  this.router.navigate(['collection', this.selectedCollection, 'document', doc.document_name])
}
}
